@import '../Field/field.css';

:host {
    display: block;
}

.field {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.label {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    color: var(--color-text);
    height: 55px;
    display: flex;
    align-items: center;
}

.input {
    height: 63px;
    width: 100%;
    display: block;

    border: none;
    outline: none;
    padding: 0;
    padding-bottom: 23px;
    transition-property: border-color;
    transition-duration: 500ms;
    transition-timing-function: ease;

    font-family: inherit;
    font-weight: 100;
    font-size: 36px;

    color: var(--color-text);
    border-bottom: 4px solid var(--color-shade-20);
    background-color: var(--color-background);

    &:disabled {
        border-bottom-color: var(--color-disabled-border);
        border-bottom-style: dashed;
    }

    &:focus:not(:read-only) {
        border-color: var(--color-secondary);
    }

    &::placeholder {
        color: var(--color-shade-60);
    }
}

.invalid .input {
    border-color: var(--color-error);

    &:focus {
        border-color: var(--color-error);
    }
}
